import React, { useState, useEffect } from "react";
import { Table } from "antd";
import {
  User1,
  User2,
  User3,
  User4,
  User5,
  User6,
  User7,
  User8,
  User9,
  User10,
  User11,
  User12,
} from "../../../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import AuthUser from "../../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../../components/Spinner";
import CrewChangeEditModal from "../../../../components/Administration/employees/CrewChangeEditModal";

const CrewChangeTable = ({ crew_changes, colaboradores }) => {
  const { t } = useTranslation();

  const [crew_change, setcrew_change] = useState();
  const [crew_changeselecionado, setcrew_changeSelecionado] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [selectedUserIds, setSelectedUserIds] = useState([]);

  useEffect(() => {
    setcrew_change(crew_changes);
  }, [crew_changes]);

  const handleSubmissionSuccess = (crew_changes) => {
    setcrew_change(crew_changes);
  };

  const chamarModalEliminar = (idSelecionado) => {
    setcrew_changeSelecionado(idSelecionado);
    const editButton = document.getElementById("triggerModalEliminar");
    if (editButton) {
      editButton.click();
    }
  };

  const chamarModalEdit = (idSelecionado) => {
    setcrew_changeSelecionado(idSelecionado);
    const editButton = document.getElementById("triggerModalEdit");
    if (editButton) {
      editButton.click();
    }
  };

  const today = new Date();

  const calculateExpirationInfo = (trainingExpiration) => {
    const expirationDate = new Date(trainingExpiration);
    expirationDate.setFullYear(expirationDate.getFullYear());

    const timeDiff = expirationDate.getTime() - today.getTime();
    const daysToExpire = Math.ceil(timeDiff / (1000 * 3600 * 24));

    const status =
      daysToExpire > 0 && daysToExpire <= 90
        ? "Prestes a expirar"
        : daysToExpire > 0
        ? "Valido"
        : "Expirado";

    return { daysToExpire, status };
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: t("Colaborador"),
      dataIndex: "sigla",
      render: (text, record) => (
        <div
          className="d-flex align-items-center p-2 mb-2"
          style={{
            borderRadius: "8px",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              backgroundColor: "#dee2e6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            <img
              src={url_root + "/storage/" + record?.colaborador?.fotografia}
              className="avatar rounded-circle"
              width={32}
              height={32}
              alt=""
            />
          </div>
          <div style={{ flexGrow: 1 }}>
            <div style={{ fontWeight: "bold", color: "#888" }}>
              {record?.colaborador?.name}
            </div>
            <div style={{ fontSize: "12px", color: "#6c757d" }}>
              {record?.colaborador?.cargo?.designacao}
            </div>
          </div>
        </div>
      ),
      sorter: (a, b) => a.sigla.length - b.sigla.length,
    },
    {
      title: "Projeto",
      dataIndex: "sigla",
      render: (text, record) => (
        <div
          className="d-flex align-items-center p-2 mb-2"
          style={{
            borderRadius: "8px",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "20%",
              backgroundColor: "#dee2e6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            <img
              src={url_root + "/storage/" + record?.posto?.cliente?.logo}
              className="avatar rounded-square"
              width={32}
              height={32}
              alt=""
            />
          </div>
          <div style={{ flexGrow: 1 }}>
            <div style={{ fontWeight: "bold", color: "#888" }}>
              {record?.posto?.codigo} - {record?.posto?.nome} -{" "}
              {record?.posto?.cliente?.nome}
            </div>
            <div style={{ fontSize: "12px", color: "#6c757d" }}>
              {record?.tipo == 1 ? (
                <>
                  {" "}
                  {" Entrou: "}
                  {new Date(record.data_emissao).toLocaleDateString()}
                  {" - Sai em: "}
                  {new Date(record.data_expiracao).toLocaleDateString()}
                </>
              ) : (
                <>
                  {" Saiu: "}
                  {new Date(record.data_expiracao).toLocaleDateString()}
                </>
              )}
            </div>
          </div>
        </div>
      ),
      sorter: (a, b) => a.sigla.length - b.sigla.length,
    },
    {
      title: t("Estado"),
      dataIndex: "estado",
      render: (text, record) => (
        <>
          <span
            className={`badge ${
              record.tipo == 2
                ? "badge-danger"
                : record.tipo == 1
                ? "badge-success"
                : ""
            }`}
          >
            {record.tipo == 1 ? "Entrou" : "Saiu"}
          </span>
        </>
      ),
      sorter: (a, b) => a.estado.length - b.estado.length,
    },
    {
      title: t("Action"),
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <span
              className="dropdown-item"
              title={record?.sigla}
              onClick={() => chamarModalEdit(record)}
            >
              <i className="fa fa-pencil m-r-5" /> {t("Edit")}
            </span>
            <span
              className="dropdown-item"
              title={record?.sigla}
              onClick={() => chamarModalEliminar(record)}
            >
              <i className="fa fa-trash m-r-5" /> {t("Delete")}
            </span>
          </div>
        </div>
      ),
    },
  ];

  const handleExportarCrewChangePDF = async (
    crew_change,
    url_root,
    getMissao
  ) => {
    const doc = new jsPDF();

    const renderPDFContent = (startY) => {
      doc.setFontSize(14);
      doc.text("Relatório de Crew Change", 105, startY, { align: "center" });
      doc.setLineWidth(0.5);
      doc.line(10, startY + 5, 200, startY + 5);

      const columns = [
        { header: "Colaborador", dataKey: "colaborador" },
        { header: "Cargo", dataKey: "cargo" },
        { header: "Projeto", dataKey: "projeto" },
        { header: "Tipo", dataKey: "tipo" },
        { header: "Entrada", dataKey: "entrada" },
        { header: "Saída", dataKey: "saida" },
      ];

      const data = crew_change.map((item) => ({
        colaborador: item?.colaborador?.name || "",
        cargo: item?.colaborador?.cargo?.designacao || "",
        projeto: `${item?.posto?.codigo || ""} - ${item?.posto?.nome || ""} - ${
          item?.posto?.cliente?.nome || ""
        }`,
        tipo: item?.tipo === 1 ? "Entrou" : "Saiu",
        entrada:
          item?.tipo === 1
            ? new Date(item?.data_emissao).toLocaleDateString()
            : "-",
        saida: new Date(item?.data_expiracao).toLocaleDateString(),
      }));

      autoTable(doc, {
        head: [columns.map((col) => col.header)],
        body: data.map((row) => columns.map((col) => row[col.dataKey])),
        startY: startY + 10,
        styles: { fontSize: 10 },
      });

      doc.save("crew_change.pdf");
    };

    // Tentar carregar o logotipo
    try {
      const imageUrl = `${url_root}/storage/${getMissao()?.imagem}`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onloadend = function () {
        const base64data = reader.result;
        doc.addImage(base64data, "JPEG", 10, 10, 30, 20);
        renderPDFContent(38); // com logo
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.warn("Erro ao carregar imagem. Exportando sem logotipo.");
      renderPDFContent(20); // sem logo
    }
  };

  if (loading)
    return (
      <>
        <Spinner>
          <ToastContainer />
        </Spinner>
      </>
    );
  else
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-danger mb-3"
              onClick={() =>
                handleExportarCrewChangePDF(
                  crew_change,
                  url_root,
                  getMissao
                )
              }
            >
              <i className="fa fa-file-pdf" /> Exportar PDF
            </button>

            <div className="table-responsive">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={crew_change}
                rowKey={(record) => record.id}
              />

              <CrewChangeEditModal
                onSubmissionSuccess={handleSubmissionSuccess}
                crew_change={crew_changeselecionado}
              />

              <DeleteModal
                objectoName={t("Registo")}
                onSubmissionSuccess={handleSubmissionSuccess}
                id={crew_changeselecionado?.id}
                endpoint={"crew-change"}
              />

              <span
                data-bs-toggle="modal"
                data-bs-target="#edit_crew_change_modal"
                id="triggerModalEdit"
              ></span>

              <span
                data-bs-toggle="modal"
                data-bs-target="#delete"
                id="triggerModalEliminar"
              ></span>
            </div>
          </div>
        </div>
        <ToastContainer />
      </>
    );
};

export default CrewChangeTable;
